export const pageSize = 10;
export const RSPBODY = "data";
export const RETCODE = "code";
export const RETDESC = "msg";
export const SUCCESS = 0;



// WEBPACK FOOTER //
// ./src/assets/js/const.js